<div>
  <div mat-dialog-content>
    <form>
      <div class="row m-t-20">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>DIAGNOSTICO</mat-label>
            <input
              (input)="searchDiagnosticsByKeyPress($event)"
              [(ngModel)]="searchDiagnostic"
              aria-autocomplete="none"
              autocomplete="nope"
              matInput
              name="medicamento"
              type="text"
            />
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
</div>
<div [hidden]="!isDataLoaded" class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card">
      <div class="body overflow-auto">
        <div class="responsive_table">
          <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef mat-sort-header>ID CIM10</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.idCIM10}}">{{ row.idCIM10 }}</mat-cell>
            </ng-container>


            <ng-container matColumnDef="nombre">
              <mat-header-cell *matHeaderCellDef mat-sort-header>NOMBRE</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.nameCIM10}}"><span
                class="mobile-label">Nombre:</span>{{ row.nameCIM10 }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="code">
              <mat-header-cell *matHeaderCellDef mat-sort-header>CODIGO</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.code}}"><span
                class="mobile-label">Codigo:</span>{{ row.code }}
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
            </mat-row>
          </table>
          <!-- Loading spinner -->
          @if (data.isTblLoading) {
            <div class="tbl-spinner">
              <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
              </mat-progress-spinner>
            </div>
          }
          @if (!data.isTblLoading) {
            <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
              Sin datos
            </div>
          }
          <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0" [pageSizeOptions]="[5, 10, 25, 100]"
                         [pageSize]="10">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

